<template>
  <div>
      <main-header></main-header>
      <div class="pagebanner1" :style="{background:'url('+ banner.img +') center 0 no-repeat'}">
        <div>{{banner.title}}</div>
      </div>
      <div class="contactbox">
        <div class="w1200">
          <div class="title">
            <h1>{{about.title}}</h1>
            <span>{{about.describe}}</span>
          </div>
          <div class="contact">
            <div class="left">
              <img :src="about.img" alt="">
            </div>
            <div class="right">
              <h1>{{language[languagetype].contact}}</h1>
              <span>
                {{language[languagetype].iphone}}：<font class="sp1">{{contact.iphone}}</font>
              </span>
              <span>
                {{language[languagetype].address}}：{{contact.address}}
              </span>
              <span>
                {{language[languagetype].wechat}}：{{contact.wx}}
              </span>
              <span>
                {{language[languagetype].email}}：{{contact.email}}
              </span>
              <span class="mt30">
                {{language[languagetype].code}}
              </span>
              <div class="picbox">
                <img v-for="(img,index) in contact.imgs" :key="index" :src="img" alt="" >
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import MainHeader from './header'
import Fetch from '../js/ajaxa'
let languagetext = require('../js/contact.json')
export default {
  name: 'about',
  data () {
    return {
      banner: {
        img: '',
        title: ''
      },
      about: {
        title: '',
        describe: ''
      },
      contact: {
        iphone: '',
        address: '',
        wx: '',
        email: '',
        imgs: []
      },
      lang: 1,
      language: {},
      languagetype: 'cn'
    }
  },
  methods: {
  },
  components: {
    MainHeader
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    that.username = JSON.parse(localStorage.getItem('username'))
    Fetch.post('Api/config', {
    }).then((res) => {
      that.logo = res.image
    }).catch(err => {
      console.log(err)
    })
  },
  beforeCreate () {
    const that = this
    Fetch.post('Api/contact', {
    }).then((res) => {
      that.banner.img = res.banner
      that.banner.title = res.sub_title
      that.about.title = res.title
      that.about.describe = res.describe
      that.about.img = res.image
      that.contact.iphone = res.number
      that.contact.address = res.address
      that.contact.wx = res.wx
      that.contact.email = res.email
      that.contact.imgs = res.codes
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebanner1{height: 400px;overflow: hidden;display: flex;align-items: center;justify-content: center;font-size: 40px;color: #fff;}
  .contactbox{height: auto;padding: 50px 0;background-color: #fff;}
  .contactbox .title h1{width: 100%;height: 60px;line-height: 60px;font-size: 40px;}
  .contactbox .title span{width: 100%;line-height: 30px;font-size: 16px;}
  .contact{width: 100%;height: auto;overflow: hidden;margin-top: 20px;}
  .contact .left{width: 550px;float: left;}
  .contact .left img{width: 100%;height: auto;}
  .contact .right{width: 563px;float: right;}
  .contact .right h1{display: block;width: 100%;height: 40px;margin-top: 28px;font-size: 20px;margin-bottom: 12px;}
  .contact .right span{display: block;line-height: 40px;font-size: 16px;}
  .contact .right .mt30{margin-top: 30px;}
  .contact .right span .sp1{color: #004EFF;font-size: 20px;}
  .contact .right span .sp2{color: #AFAFBF;font-size:14px;}
  .picbox{width: 100%;height: auto;}
  .picbox img{width: 125px;height: 125px;}
</style>



// WEBPACK FOOTER //
// src/page/contact.vue